﻿import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadTypeDetail") return;

    initTinymce('Description', 300);

});

